import { Box, HStack, Switch, Text } from "@chakra-ui/react"
import { useEffect, useState } from "react"
import { i18nTogglerActiveKey, i18nVisibleKey } from "./I18nextProvider"

/** Match legacy Pathwright fullscreen stacking (legacy `Fullscreen.js`). */
const FULLSCREEN_LAYER_BASE = 999999999
const FULLSCREEN_LAYER_OVERLAY = 2020

const Togglei18nKeys = () => {
  const [on, setOn] = useState(
    () =>
      eval(JSON.parse(window.localStorage.getItem(i18nVisibleKey) || "false")) || false
  )
  const [active, setActive] = useState(
    () => !!window.sessionStorage.getItem(i18nTogglerActiveKey)
  )

  useEffect(() => {
    const handleEvent = (e: Event) => {
      const ce = e as CustomEvent<{ active: boolean }>
      setActive(ce.detail.active)
    }
    window.addEventListener(i18nTogglerActiveKey, handleEvent)
    return () => {
      window.removeEventListener(i18nTogglerActiveKey, handleEvent)
    }
  }, [])

  const handleToggle = (checked: boolean) => {
    setOn(checked)
    window.localStorage.setItem(i18nVisibleKey, String(checked))
    window.dispatchEvent(
      new CustomEvent(i18nVisibleKey, {
        detail: {
          on: checked
        }
      })
    )
  }

  if (!active) return null

  return (
    <Box
      zIndex={FULLSCREEN_LAYER_BASE + FULLSCREEN_LAYER_OVERLAY + 10}
      w="60px"
      h="60px"
      borderRadius="full"
      bg="blue.600"
      position="fixed"
      bottom="20px"
      left="20px"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      boxShadow="0 0 15px 10px rgba(0, 0, 0, 0.1)"
    >
      <Switch.Root
        colorPalette="blue"
        checked={!!on}
        onCheckedChange={(e) => handleToggle(e.checked)}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap={1}
        cursor="pointer"
      >
        <Switch.HiddenInput />
        <Text fontSize="2xs" color="white" fontWeight="normal" mb={0} userSelect="none">
          i18n
        </Text>
        <HStack>
          <Switch.Control>
            <Switch.Thumb />
          </Switch.Control>
        </HStack>
      </Switch.Root>
    </Box>
  )
}

Togglei18nKeys.displayName = "Togglei18nKeys"

export default Togglei18nKeys
